module.exports = __webpack_public_path__ + "assets/09821f9aeae6eff8d5e4a2fa60c82237.png";